import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { RobotoUserConfigKey } from "../ConfigRecords";

export function getQueryKey(key: RobotoUserConfigKey) {
  return ["userConfig", key];
}

/**
 * Fetch a user config value from the backend.
 *
 * @template T The type of the config value to fetch
 * @param key - The config key to fetch
 * @returns The config value
 */

export function useUserConfig<T = unknown>(key: RobotoUserConfigKey) {
  const { configService } = useDomainServices();

  return useQuery({
    queryKey: getQueryKey(key),
    queryFn: ({ signal }) => {
      return configService.getUserConfig<T>(key, {
        abortSignal: signal,
      });
    },
  });
}
